import React from 'react'

import { Asset, AssetProps } from '../Asset/Asset'
import { avatar } from './Avatar.css'

export type AvatarProps = {
  image?: AssetProps['thumbnail'] | null
  image_alt_text?: string
  field1: string | null | undefined
  field2?: string | null
  field3?: string | null
  field4?: string | null
  size: 'small' | 'medium' | 'large'
}

export const Avatar = ({
  image,
  image_alt_text,
  field1,
  field2,
  field3,
  field4,
  size = 'small',
}: AvatarProps) => {
  return (
    <>
      <div className={avatar._}>
        <div className={avatar.imageContainer[size]}>
          {!!image && (
            <Asset
              altText={image_alt_text}
              objectFit={'cover'}
              sizes={size === 'small' ? '48px' : size === 'medium' ? '75px' : '104px'}
              srcSetWidths={[48, 75, 104]}
              thumbnail={image}
            />
          )}
        </div>
        <div className={avatar.fieldsContainer._}>
          <div className={avatar.fieldsContainer.field1._}>{field1}</div>
          {!!field2 && <div>{field2}</div>}
          {!!field3 && <div>{field3}</div>}
          {!!field4 && <div>{field4}</div>}
        </div>
      </div>
    </>
  )
}

export default Avatar
